import { cn } from '@/utils/cn';
import { TextField, TextFieldProps } from '@mui/material';

interface Props {
	title: string;
	value: string;
	setState: (value: string) => void;
	width: string;
	containerClassName?: string;
	labelClassName?: string;
	multiline?: boolean;
	rows?: number;
	inputStyle?: React.CSSProperties;
	autoFocus?: boolean;
	required?: boolean;
}

const SimpleInputText = ({ title, value, setState, width, ...rest }: Props) => {
	return (
		<div className={cn(`flex-col`, rest.containerClassName)}>
			<div className={cn("text-[12px] text-[#4A4A4A]", rest.labelClassName)}>
				{title}
				{rest.required && <span className="text-red">{' '}*</span>}
			</div>
			<TextField
				autoFocus={rest.autoFocus}
				variant="outlined"
				value={value}
				sx={{ width: `${width}` }}
				inputProps={{ style: { padding: '0px 10px', height: '2rem', ...(rest.inputStyle || {}) } }}
				onChange={(event) => {
					setState(event.target.value);
				}}
				multiline={rest.multiline}
				rows={rest.rows}
				required={rest.required}
			/>
		</div>
	);
};

export default SimpleInputText;
